import agent from 'api/agent';

export const Common = {
    UploadImage: (fileFormData: any) => agent.requests.post(`/File/uploadimage`, fileFormData),
};
